"use client";

import { logoutAction } from "@/app/actions/auth";

export function LogoutButton() {
  return (
    <form action={logoutAction}>
      <button type="submit" className="hover:text-stone-100">
        Abmelden
      </button>
    </form>
  );
}
